import script from "./IndexApprovalStamp.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexApprovalStamp.vue?vue&type=script&setup=true&lang=js"

import "./IndexApprovalStamp.vue?vue&type=style&index=0&id=03662fb2&lang=css"

const __exports__ = script;

export default __exports__